<template>
  <div class="bg-content2-fm">
    <div class="m-auto max-w-sm bg-white rounded-md p-3 mb-5 ">
        <div class="text-center text-xl color-main2">
            Ước tính khoản vay
        </div>
        <custom-range :key="amount" :on-update="updateValue" :color="'#F1674A'" :amount="amount" :step="step" :min="min" :max="max"></custom-range>
        <div class="mt-3">
            <div class="font-bold">
                Thời hạn vay
            </div>
            <div class="mt-2">
                <span @click="changeMonth(item)" v-for="item in months" :key="item" class="border-non-active pt-1 pb-1 pl-2 pr-2 mr-2 rounded-md cursor-pointer" :class="{ bactive: month == item }">
                    {{item}} tháng
                </span>
            </div>
        </div>

        <div class="mt-4">
            <div class="grid grid-cols-2 mt-1 text-sm">
                <div class="text-gray-400">Số tiền trả mỗi tháng</div>
                <div class="text-right font-bold"> {{pay_of_month | toThousandFilter}} đ </div>
            </div>
            <div class="grid grid-cols-2 mt-1 text-sm">
                <div class="text-gray-400">Ngày bắt đầu trả</div>
                <div class="text-right font-bold"> {{datePay}} </div>
            </div>
            <div class="grid grid-cols-2 mt-1 text-sm">
                <div class="text-gray-400">Số tiền thực nhận</div>
                <div v-b-toggle.collapse-1 class=" font-bold color-main2 text-right"> 
                     <span class="inline-block"> {{amount | toThousandFilter}} đ </span> 
                    <span class="active_collsape">
                        <b-icon class="active_collsape" scale="1" icon="chevron-down" variant="main-color" ></b-icon>
                    </span>
                    <span   class="not_active_collsape">
                        <b-icon class="not_active_collsape" scale="1" icon="chevron-up" variant="main-color" ></b-icon>
                    </span> 
                </div>
            </div>

            <b-collapse id="collapse-1" class="">
                <div class="pl-3 pt-1 border-b-2">
                    <div class="grid grid-cols-2 text-sm">
                        <div class="text-gray-400">Tiền gốc</div>
                        <div class="text-right"> {{amount | toThousandFilter}} đ</div>
                    </div>
                    <div class="grid grid-cols-2 mt-1 text-sm">
                        <div class="text-gray-400">Lãi</div>
                        <div class="text-right"> {{ (total_pay - amount - service_fee) | toThousandFilter }} đ</div>
                    </div>
                    <div class="grid grid-cols-2 mt-1 text-sm">
                        <div class="text-gray-400">Phí dịch vụ</div>
                        <div class="text-right"> {{service_fee | toThousandFilter}} đ </div>
                    </div>
                </div>
            </b-collapse>

            <div class="grid grid-cols-2 mt-1 text-sm">
                <div class="text-gray-400">Tổng thanh toán tạm tính</div>
                <div class="text-right font-bold">  {{total_pay | toThousandFilter}} đ </div>
            </div>
        </div>
        <div @click="register" class="bg-main2 p-2 text-center text-white font-bold rounded-md mt-3">
            Vay ngay
        </div>

    </div>
</div>
</template>

<script>
import CustomRange from '../../components/CustomRange.vue'
import {getDateAdd30} from '@/filters/index'

export default {
    components: {
        CustomRange
    },
    data() {
        return {
            min: 2000000,
            max: 20000000,
            step: 1000000,
            amount: 10000000,
            month: 9,
            months: [9,12,15],
            rate: 0.4/12,
            pay_of_month: 0,
            total_pay: 0,
            service_fee: 0,
            datePay: getDateAdd30()
        }
    },
    methods: {
        register(){
            window.location.href = 'https://vclick.vn'
        },
        changeMonth(month){
            this.month = month
            this.PMT(this.rate,this.month,this.amount)
        },
        updateValue(amount){
            this.amount = amount
            //this.check_month()
            this.PMT(this.rate,this.month,this.amount)
        },
        PMT(ir,np, pv, fv = 0){ 
        // ir: interest rate
        // np: number of payment
        // pv: present value or loan amount
        // fv: future value. default is 0
        this.service_fee = this.month*30*0.0008*pv;
        this.service_fee = this.service_fee.toFixed()
        if(!np){
            this.pay_of_month = pv
            this.total_pay = pv
        } else {
            var presentValueInterstFector = Math.pow((1 + ir), np);
            var pmt = ir * pv  * (presentValueInterstFector + fv)/(presentValueInterstFector-1) + 30*0.0008*pv;
            
            this.pay_of_month = pmt.toFixed()
            this.total_pay = (this.pay_of_month * this.month).toFixed()
        }
        }
    },
    created() {
        this.updateValue(10000000)
    },
}
</script>

<style>
.not-collapsed{
    color: #f1674a;
} 
.not-collapsed .active_collsape{
    display: none;
}

.collapsed .active_collsape{
    display: inline-block;
}

.not-collapsed .not_active_collsape{
    display: inline-block;
}

.collapsed .not_active_collsape{
    display: none;
}
</style>